import { buildInputTableCols, ErpInputTableV2, type InputTableColumn } from '@/components/custom/erp/input-table-v2';
import { AritoDialog, AritoForm, AritoIcon } from '@/components/custom/erp';
import { ColumnMapping } from '../../utils/excel-import';
import { ValidationError } from '../../utils/validation';
import { Button } from '@/components/ui/button';

interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errors: ValidationError[];
  columnMapping: Record<string, ColumnMapping>;
}

const ERROR_MESSAGE = 'Giá trị không hợp lệ hoặc không có trong danh mục.';

const getExcelColumnLetter = (index: number): string => {
  let result = '';
  let currentIndex = index + 1;

  while (currentIndex > 0) {
    currentIndex -= 1;
    result = String.fromCharCode(65 + (currentIndex % 26)) + result;
    currentIndex = Math.floor(currentIndex / 26);
  }

  return result;
};

const getCellPosition = (error: ValidationError, columnMapping: Record<string, ColumnMapping>): string => {
  const mapping = Object.values(columnMapping).find(column => column.key === error.field);

  if (!mapping) {
    return `Dòng ${error.row + 1}`;
  }

  const columnLetter = getExcelColumnLetter(mapping.index);
  const excelRow = error.row + 1;
  return `${columnLetter}${excelRow}`;
};

const columns: InputTableColumn[] = buildInputTableCols([
  {
    headerName: 'Loại',
    field: 'type',
    width: 80,
    valueGetter: row => row?.type
  },
  {
    headerName: 'Ràng buộc dữ liệu trên chương trình',
    field: 'message',
    width: 450,
    valueGetter: row => row?.message
  },
  {
    headerName: 'Vị trí',
    field: 'position',
    width: 120,
    valueGetter: row => row?.position
  }
]);

export const ErrorDialog = ({ open, onClose, errors, columnMapping }: ErrorDialogProps) => {
  const groupedErrors = errors.reduce<Record<number, ValidationError[]>>((acc, error) => {
    const rowKey = error.row;
    if (!acc[rowKey]) {
      acc[rowKey] = [];
    }
    acc[rowKey].push(error);
    return acc;
  }, {});

  const errorRows = Object.entries(groupedErrors)
    .sort((a, b) => Number(a[0]) - Number(b[0]))
    .map(([row, rowErrors], index) => {
      const positions = rowErrors.map(error => getCellPosition(error, columnMapping)).filter(Boolean) as string[];

      return {
        id: `${row}-${index}`,
        type: 'Lỗi',
        message: ERROR_MESSAGE,
        position: positions.length > 0 ? positions.join(', ') : `Dòng ${Number(row) + 1}`
      };
    });

  return (
    <AritoDialog open={open} onClose={onClose} title='Chi tiết kết quả Import' maxWidth='lg' zIndex={120}>
      <div className='flex flex-col gap-4'>
        <AritoForm
          mode='view'
          hasAritoActionBar={false}
          className='h-auto min-w-[725px]'
          headerFields={
            <div className='flex flex-col gap-2'>
              <ErpInputTableV2
                rows={errorRows}
                columns={columns}
                height={360}
                actions={{
                  export: () => console.log('Export clicked')
                }}
              />
            </div>
          }
          bottomBar={
            <Button onClick={onClose} variant='outline'>
              <AritoIcon icon={885} className='mx-1' />
              Đóng
            </Button>
          }
        />
      </div>
    </AritoDialog>
  );
};
